module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Theme-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": _vm.tabValue
    },
    on: {
      "tab-click": _vm.setUrl
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-General",
      "name": "general"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-General"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabGeneralText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "file": _vm.fieldsData.settingsFile,
      "loading": _vm.loading,
      "text": _vm.fieldsData.settingsText
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-App",
      "name": "app"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-App"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabAppText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "file": _vm.fieldsData.appFile,
      "loading": _vm.loading,
      "text": _vm.fieldsData.appText
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-Email",
      "name": "email"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-Email"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabEmailText')))]), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailBasicText,
      "title": _vm.$t('themeThemeViewBasicSettingsTitle'),
      "data-qa": "Content-Theme-Tab-Email-Basic_Settings"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailTemplateText,
      "title": _vm.$t('themeThemeViewWelcomeTemplateTitle'),
      "data-qa": "Content-Theme-Tab-Email-Welcome_Template"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.ClaimDevicesTemplateText,
      "title": _vm.$t('themeThemeViewClaimDevicesTemplateTitle'),
      "data-qa": "Content-Theme-Tab-Email-Claim_Devices_Template"
    }
  }), _vm._v(" "), _c('theme-view', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.emailSenderText,
      "title": _vm.$t('themeThemeViewSenderConfigureTitle'),
      "data-qa": "Content-Theme-Tab-Email-Email_Settings"
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "data-qa": "Content-Theme-TabContent-Legal",
      "name": "legal"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label",
      "data-qa": "Content-Theme-Tab-Legal"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalText')))]), _vm._v(" "), _c('div', {
    staticClass: "bs-callout"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalContentTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "themeTabLegalContentBody",
      "tag": "p"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.legalUrl,
      "place": "legalUrl",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.legalUrl))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.muranoTermsUrl,
      "place": "muranoTermsUrl",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('themeTabLegalToSText')))])])], 1), _vm._v(" "), _c('theme-legal', {
    attrs: {
      "loading": _vm.loading,
      "text": _vm.fieldsData.legalPoliciesText,
      "title": _vm.$t('themeThemeViewLegalPoliciesTitle')
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-157624c4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Theme/Theme.vue
// module id = 953
// module chunks = 3